module.exports = __webpack_public_path__ + "static/edge-drip-mask-b595789c0bd3068b8bfec2e6ab09505a.png";